export class IDeviceTableNode {
  nodeId?: number;

  presenceProduit?: number;

  dureeAbsence?: number;

  dureeTotal?: number;

  dureeAbsenceTotal?: number;

  compteurAbscence?: number;

  firmwareVersion?: number;

  gblVersion?: number;

  produitInit?: number;

  serialNumber?: string;

  qualityZB?: number;

  constructor(presenceProduit = 0) {
    this.presenceProduit = presenceProduit;
    this.qualityZB = -1;
  }
}

export const DeviceTableNodePresence = [
  { ref: 0, label: 'devicetable.presence.0' },
  { ref: 1, label: 'devicetable.presence.1' },
  { ref: 2, label: 'devicetable.presence.2' },
];
